declare global {
  interface Window { 
    Cypress: any
  }
}

const isTesting = !!(window).Cypress && (window).Cypress?.originalConfig?.projectId !== 'Smoke Tests';

export default isTesting;
